"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Timer = _interopRequireDefault(require("./common/Timer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ButtonType = function ButtonType(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? "link" : _ref$type,
    children = _ref.children,
    onClick = _ref.onClick;
  if (type === "pricing") {
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.set("tier", "VIP");
    urlParams.set("term", "monthly");
    var newUrl = "/boost-pricing?".concat(urlParams.toString());
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: newUrl
    }, children);
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _react["default"].createElement("div", {
      onClick: onClick,
      className: "cursor-pointer"
    }, children)
  );
};
var BoostCountDownBanner = function BoostCountDownBanner(_ref2) {
  var text = _ref2.text,
    deadline = _ref2.deadline,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? "pricing" : _ref2$type,
    _ref2$onClick = _ref2.onClick,
    onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
    _ref2$belowMd = _ref2.belowMd,
    belowMd = _ref2$belowMd === void 0 ? false : _ref2$belowMd,
    _ref2$textClassName = _ref2.textClassName,
    textClassName = _ref2$textClassName === void 0 ? "" : _ref2$textClassName,
    _ref2$showCountdown = _ref2.showCountdown,
    showCountdown = _ref2$showCountdown === void 0 ? true : _ref2$showCountdown;
  return /*#__PURE__*/_react["default"].createElement(ButtonType, {
    onClick: onClick,
    type: type
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex text-white justify-center items-center top-0 ".concat(type === "upgrade" ? "mt-2 py-4" : "pb-2", " left-0 w-full px-4"),
    style: {
      background: "linear-gradient(90deg, #AE3F5A, #8645C8)",
      zIndex: 999
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex xs:space-x-4 md:space-x-10 items-center justify-items-center ".concat(showCountdown ? "mt-2" : "")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-col space-x-2 text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-left ".concat(textClassName)
  }, text)), showCountdown && /*#__PURE__*/_react["default"].createElement(_Timer["default"], {
    classList: "text-black flex-shrink-0",
    deadline: deadline
  }))));
};
var _default = exports["default"] = BoostCountDownBanner;